import { render, staticRenderFns } from "./BuildingDistances.vue?vue&type=template&id=689a28be&scoped=true"
import script from "./BuildingDistances.vue?vue&type=script&lang=js"
export * from "./BuildingDistances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689a28be",
  null
  
)

export default component.exports